module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f9dce53613d5f85b311ce9f84423c08b.svg";